var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#e13556",
    viewBox: "0 0 92.775 126.595",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.567,225.236c-25.607.019-46.57,20.976-46.325,46.376.067,6.895,2.395,13.262,5.2,19.418,9.758,21.438,23.389,40.417,37.747,58.913,2.048,2.637,4.938,2.476,7.081-.264,3.348-4.281,6.66-8.594,9.843-13,10.329-14.294,20.133-28.924,27.434-45.057,3-6.617,5.583-13.427,5.467-20.849a46.373,46.373,0,0,0-46.444-45.539m.147,58.97a16.847,16.847,0,1,1-.068-33.694,16.847,16.847,0,0,1,.068,33.694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.ec0a32892b9a6de58141522aeca9812f.svg";
export { ForwardRef as ReactComponent };